<template>
  <div class="main-slider">
    <swiper class="main-slider-swiper" :options="swiperOptions">
      <swiper-slide
        class="main-slider-slide"
        v-for="(item, index) in _.get(contentData, 'data.list')"
        :key="index"
      >
        <div
          v-if="_.get(item, 'video.videoFile.url')"
          class="main-slider-video"
        >
          <video
            class="video-container__video"
            ref="mainvideo"
            preload="auto"
            muted
            autoplay
            playsinline
            loop
          >
            <source
              :src="_.get(item, 'video.videoFile.url')"
              :type="_.get(item, 'video.videoFile.mime_type') || 'video/mp4'"
            />
          </video>
        </div>
        <div v-else class="main-slider-image">
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="_.get(item, 'mobile_image[0].devices.desktop')"
            />
            <source
              media="(max-width: 1023px)"
              :srcset="_.get(item, 'image[0].devices.tablet')"
            />
            <img :src="_.get(item, 'image[0].devices.desktop')" alt />
          </picture>
        </div>
        <div class="layer"></div>
        <div class="container">
          <div class="teaser font-21 uppercase ">{{ item.teaser }}</div>
          <div class="title font-55 uppercase bold">{{ item.title }}</div>
          <a
            :href="_.get(item, 'url.url')"
				    :target="_.get(item, 'url.url_target') == '_blank' ? '_blank' : '_self'"
            class="learn-more pointer uppercase flex al-center font-21 bold"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27.283"
              height="27.283"
              viewBox="0 0 27.283 27.283"
            >
              <path
                id="Path_1613"
                data-name="Path 1613"
                d="M584.81,0V23.85L597.054,11.38,591.6,5.928H606.17V20.49l-5.457-5.452L588.242,27.283h23.85V0Z"
                transform="translate(27.283 -584.81) rotate(90)"
                fill="#ffffff"
              />
            </svg>
            {{ _.get(item, "url.title") || $fn.tr("გაიგე მეტი") }}
          </a>
        </div>
      </swiper-slide>
    </swiper>

    <div class="swiper-navigation-button swiper-prev">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7.857"
        height="10"
        viewBox="0 0 7.857 10"
      >
        <path
          id="Icon_material-play-arrow"
          data-name="Icon material-play-arrow"
          d="M12,7.5v10l7.857-5Z"
          transform="translate(-12 -7.5)"
          fill="#fff"
        />
      </svg>
    </div>

    <div class="swiper-navigation-button swiper-next">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7.857"
        height="10"
        viewBox="0 0 7.857 10"
      >
        <path
          id="Icon_material-play-arrow"
          data-name="Icon material-play-arrow"
          d="M12,7.5v10l7.857-5Z"
          transform="translate(-12 -7.5)"
          fill="#fff"
        />
      </svg>
    </div>

    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  data() {
    return {
      swiperOptions: {
        speed: 800,
        loop: true,
        autoplay: {
          delay: 4000
        },
        slidesPerView: 1,
        navigation: {
          nextEl: ".main-slider .swiper-next",
          prevEl: ".main-slider .swiper-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true
        }
      }
    };
  },
  mounted() {
    setTimeout(() => {
      this.$refs.mainvideo?.addEventListener(
        "pause",
        () => {
          this.$refs.mainvideo.load();
        },
        false
      );
    }, 400);
  }
};
</script>

<style lang="scss">
.main-slider {
  width: 100%;
  height: 610px;
  position: relative;
  @media (max-width: 1024px) {
    .swiper-navigation-button {
      bottom: 21px;
    }
  }
  @media (max-width: 767px) {
    height: 377px;
    .font-55 {
      font-size: 34px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-line-clamp: 3;
    }
    .teaser.font-21 {
      display: none;
    }
  }
  @media (max-width: 510px) {
    // height: 305px;
  }
  .teaser.font-21 {
    margin-bottom: 10px;
  }
  .swiper-pagination {
    bottom: 50px;
    left: 50%;
    transform: translate(-50%, 0px);

    @media (max-width: 1023px) {
      bottom: 65px;
    }

    @media (max-width: 767px) {
      bottom: 44px;
      left: 50%;
    }
    .swiper-pagination-bullet {
      margin-right: 10px;
      width: 10px;
      height: 10px;
      background: rgba(255, 255, 255, 0.33);
      &.swiper-pagination-bullet {
        background: rgba(255, 255, 255, 1);
      }
    }
  }
  .main-slider-swiper {
    height: 100%;
    position: relative;
  }
  .swiper-navigation-button {
    @media (max-width: 1023px) {
      bottom: 35px;
    }
    @media (max-width: 767px) {
      bottom: 11px;
    }
  }
  img {
    @media (max-width: 510px) {
      // object-fit: unset !important;
    }
  }
  img,
  video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }
  .container {
    z-index: 3;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    bottom: 144px;
    height: 100%;
    @media (max-width: 1023px) {
      bottom: 159px;
    }
    @media (max-width: 767px) {
      bottom: 130px;
    }
  }
  .layer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background: linear-gradient(
      to bottom,
      rgba(26, 26, 26, 0) 0%,
      rgba(26, 26, 26, 0.7) 100%
    );
    z-index: 2;
  }
  .learn-more {
    margin-top: 89px;
    width: fit-content;
    height: 50px;
    border: 2px solid #ffffff;
    background: $black;
    padding: 0 10px;
    @media (max-width: 767px) {
      margin-top: 34px;
      height: 40px;
      font-size: 16px;
      svg {
        width: 20px;
      }
    }
    svg {
      transition: 0.2s ease;
      margin-right: 10px;
      will-change: transform;
    }
    &:hover {
      svg {
        transform: rotate(-45deg);
      }
    }
  }
  * {
    color: $white;
  }
}

.main-slider{
  position: relative;
  &-swiper{
    position: absolute !important;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

    padding-bottom: calc(100% /  3.14754098361);
    height: auto;
    @media (max-width: 1919px){
    padding-bottom: calc(100% /  2.3606557377);

    }
    @media (max-width: 1439px){
    padding-bottom: calc(100% /  2.2393442623);

    }
    // @media (max-width: 1365px){
    // padding-bottom: calc(100% /  1.67868852459);

    // }
    @media (max-width: 1023px){
    padding-bottom: calc(100% /  1.25901639344);

    }
    @media (max-width: 767px){
    padding-bottom: calc(100% /  1.09814323607);

    }
 
}
</style>
